import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonButtonTypeDefault, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon } from '@skatteetaten/ds-icons';
import { Spinner } from '@skatteetaten/ds-progress';
import './styles.css';


const getInlineButtonPositionDefault = ()=>'left';
const getInlineButtonBrightnessDefault = ()=>'default';

var styles = {
    "button": "InlineButton-module_button__G8jmB",
    "button_withIconRight": "InlineButton-module_button_withIconRight__DY3UP",
    "button_withIconLeft": "InlineButton-module_button_withIconLeft__xGFKJ",
    "spinner": "InlineButton-module_spinner__s3BNu",
    "icon": "InlineButton-module_icon__8BCa6",
    "hide": "InlineButton-module_hide__oqYw4"
};

const InlineButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, iconPosition = getInlineButtonPositionDefault(), spinnerTitle, svgPath, accessKey, disabled, form, type = getCommonButtonTypeDefault(), ariaDescribedby, brightness = getInlineButtonBrightnessDefault(), hasSpinner, onBlur, onClick, onFocus, children }, ref)=>{
    const hasIconLeft = svgPath && iconPosition === 'left';
    const hasIconRight = svgPath && iconPosition === 'right';
    const withIconLeftClassName = hasIconLeft ? styles.button_withIconLeft : '';
    const withIconRightClassName = hasIconRight ? styles.button_withIconRight : '';
    const concatenatedClassName = `${styles.button} ${withIconLeftClassName} ${withIconRightClassName} ${className}`.trim();
    const hideClassName = hasSpinner ? styles.hide : '';
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        "data-brightness": brightness,
        accessKey: accessKey,
        form: form,
        disabled: disabled,
        type: type,
        "aria-describedby": ariaDescribedby,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        children: [
            hasIconLeft && /*#__PURE__*/ jsx(Icon, {
                className: `${styles.icon} ${hideClassName}`.trim(),
                svgPath: svgPath
            }),
            /*#__PURE__*/ jsx("span", {
                className: hideClassName,
                children: children
            }),
            hasIconRight && /*#__PURE__*/ jsx(Icon, {
                className: `${styles.icon} ${hideClassName}`.trim(),
                svgPath: svgPath
            }),
            hasSpinner && /*#__PURE__*/ jsx(Spinner, {
                className: styles.spinner,
                color: disabled ? 'black' : 'blue',
                size: 'small',
                hideTitle: true,
                children: spinnerTitle
            })
        ]
    });
});
InlineButton.displayName = 'InlineButton';

export { InlineButton, getInlineButtonBrightnessDefault, getInlineButtonPositionDefault };
